import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus } from "../../../utils";
import { RootState } from "../../../redux/store";
import { fakeElectricCharges } from "./electricChargingFakeData";
import { ElectricCharge } from "./electricChargingAPI";

export interface ElectricChargingState {
  electricChargesStatus: QueryStatus;
  electricCharges: ElectricCharge[];
}

const initialState: ElectricChargingState = {
  electricChargesStatus: "idle",
  electricCharges: [],
};

// Simulates the future backend endpoint returning the MERGED electric charges
// (CasaWatt home + our EMSP CDRs + card charges), unified format — until the API is wired.
// Only authorized charges are returned (authorizationStatus === "ALLOWED"), so the
// authorization status is not displayed in the table.
export const getElectricChargesAsync = createAsyncThunk(
  "getElectricChargesAsync/call",
  () => {
    return fakeElectricCharges;
  },
);

export const electricChargingSlice = createSlice({
  name: "electricCharging",
  initialState,
  reducers: {
    resetElectricChargesStatus(state) {
      state.electricChargesStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getElectricChargesAsync.pending, (state) => {
        state.electricChargesStatus = "processing";
      })
      .addCase(getElectricChargesAsync.fulfilled, (state, action) => {
        state.electricChargesStatus = "success";
        state.electricCharges = action.payload;
      })
      .addCase(getElectricChargesAsync.rejected, (state) => {
        state.electricChargesStatus = "failed";
      });
  },
});

export const selectElectricChargesStatus = (state: RootState) =>
  state.electricCharging.electricChargesStatus;

export const selectElectricCharges = (state: RootState) =>
  state.electricCharging.electricCharges;

export default electricChargingSlice.reducer;
